import React, { useState } from 'react';
import classes from "./checkout.module.css"
import DoubleArrow from "../../../../assets/images/red-arrow.png";
import PromptMessage from '../../../containers/promptMessage/promptMessage';
import { sixYardAxios } from '../../../../sixYardAxios';

const Checkout = (props) => {
    const amountAfterDiscount =
        ((Number(props.birthdayPaymentData?.amount) || 0))
    const [loyaltyPointsUsed, setLoyaltyPointsUsed] = useState(0);
    const [partialValue, setPartialValue] = useState(props.calculationBookingPrice?.payment_options?.down_payment);
    const [loyalty, setLoyalty] = useState(0);
    const [checkLoyaltyEnteredAmount, setCheckLoyaltyEnteredAmount] = useState(null);
    const [error, setError] = useState(null);
    const [totalAmount, setTotalAmount] = useState(amountAfterDiscount);
    const [paymentType, setPaymentType] = useState("partial");
    const [loading, setLoading] = useState(null);
    const submitHandler = async (e) => {
        e.preventDefault();
        setError(null);
        setLoading(true);
        try {
            const formData = {
                registration_id: props.birthdayRegistrationId,
                amount: paymentType === "full" ? totalAmount : partialValue,
                payment_type: paymentType,
                loyalty_points_used: loyaltyPointsUsed,
                "customer_name": "",
                "customer_email": ""
            }
            const response = await sixYardAxios.post('/payments/initiate/activity', formData);
            if (response.data.data) {
                const redirectUrl = response.data.data.redirect_url;
                props.setShowCheckout(false);
                localStorage.removeItem("Birthday Booking")
                window.scrollTo({ top: 0, behavior: 'smooth' });
                redirectUrl != null && window.open(redirectUrl, '_blank');
            }
        } catch (err) {
            setError(err.response?.data?.message || 'Something went wrong. Please try again.');
        } finally {
            setLoading(false);
        }
    };
    const formatDate = (dateStr) => {
        const date = new Date(dateStr);
        // Extract the day, date, and month components
        const days = ["SUN", "MON", "TUE", "WED", "THU", "FRI", "SAT"];
        const months = ["JAN", "FEB", "MAR", "APR", "MAY", "JUN", "JUL", "AUG", "SEP", "OCT", "NOV", "DEC"];
        const day = days[date.getDay()];
        const dayOfMonth = date.getDate().toString().padStart(2, "0"); // Ensure two digits
        const month = months[date.getMonth()];
        const year = date.getFullYear();

        return `${day}, ${dayOfMonth} - ${month} - ${year}`;
    }
    const calculateLoyaltyAmount = (e) => {
        if (e.target.value <= props.birthdayPaymentData?.loyalty_points) {
            setLoyalty(e.target.value);
        }
        else {
            setCheckLoyaltyEnteredAmount("The amount you enter greater than your points");
        }
    }
    const closeLoyaltyIssue = () => {
        setCheckLoyaltyEnteredAmount(null)
        setLoyalty("");
    }
    const loyaltySubmitHandler = (e) => {
        e.preventDefault();
        setLoyaltyPointsUsed(loyalty)
        setTotalAmount(amountAfterDiscount - (loyalty))
    }
    return (
        <div className={classes.Container}>
            <div className={classes.Path}><span>Book Birthday</span> / Checkout</div>
            <h1>Checkout</h1>
            <div className={classes.Content}>
                <div className={classes.BookingSummery}>
                    <h3>Booking Summary</h3>
                    <div className={classes.info}>
                        <p>{props.birthdayBookingDate?.time_slot}, {formatDate(props.birthdayBookingDate?.date)}</p>
                        <p>{/* {props.bookingData?.location},  */} Birthday Party</p>
                    </div>
                    <div>
                        You have
                        <span className={classes.money}> {props.birthdayPaymentData?.loyalty_points} JD </span>
                        from loyalty program, enter the amount you desire to use.
                    </div>
                    <form onSubmit={(e) => loyaltySubmitHandler(e)}>
                        <label>Amount</label><br />
                        <input placeholder='Enter amount' value={loyalty}
                            onChange={(e) => calculateLoyaltyAmount(e)} />
                        <button type='submit'>Calculate</button>
                    </form>
                </div>
                <div className={classes.PaymentSummery}>
                    <h3>Payment Summary</h3>
                    {/* {props.calculationBookingPrice?.selected_activities?.length > 0 && props.calculationBookingPrice?.selected_activities?.map((activity) => 
                    <div key={activity.id}>
                        <span>{activity.name}</span>
                        <span>{activity.base_price} JD</span>
                    </div>)} */}
                    {props.calculationBookingPrice?.items?.length > 0 && props.calculationBookingPrice?.items?.map((item, i) => 
                    <div key={i}>
                        <span><span className={classes.Quantity}>{item.quantity} X</span> {item.name}</span>
                        <span>{item.total} JD</span>
                    </div>)}
                    <div>
                        <span>Original Price</span>
                        <span>{amountAfterDiscount} JD</span>
                    </div>
                    <div className={classes.LoyaltyPoints}>
                        <span>Loyalty Program Points</span>
                        <span className={classes.Zero}>{loyaltyPointsUsed === "" ? 0 : loyaltyPointsUsed} JD</span>
                    </div>
                    <div className={classes.Total}>
                        <span>Total</span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>
                <div>
                    <h3>Payment Amount</h3>
                    <div className={classes.Note}>
                        <div className={classes.NoteIcon}>i</div>
                        <div>All packages include 1 hour birthday party </div>
                    </div>
                    <div className={classes.Radio}>
                        <span>
                            <input type="radio" checked={paymentType === "partial"} value="partial"
                                onChange={() => setPaymentType("partial")} />
                            <label className={classes.Label}>Down Payment</label>
                        </span>
                        <span>{props.calculationBookingPrice?.payment_options?.down_payment} JD</span>
                    </div>
                    <div className={classes.Radio}>
                        <span>
                            <input type="radio" checked={paymentType === "full"} value="full"
                                onChange={() => setPaymentType("full")} />
                            <label className={classes.Label}>Full Amount</label>
                        </span>
                        <span>{totalAmount} JD</span>
                    </div>
                </div>
                <div>
                    <form className={classes.FormContainer} onSubmit={(e) => submitHandler(e)}>
                        <div className={classes.Buttons}>
                            <button onClick={() => props.setShowCheckout(false)}>
                                <img
                                    src={DoubleArrow}
                                    alt=""
                                    className={classes.Icon}
                                /> BACK
                            </button>
                            <button type="submit">
                                CHECKOUT
                            </button>
                        </div>
                    </form>
                </div>
            </div>
            {error && <PromptMessage message={error} status='Oops' button='CLOSE' click={() => setError(false)} />}
            {checkLoyaltyEnteredAmount && <PromptMessage message={checkLoyaltyEnteredAmount} status='Oops' button='CLOSE' click={closeLoyaltyIssue} />}
        </div>
    )
}
export default Checkout;